// @owners { team: patients-team }
import {
  FETCH_NEXT_AVAILABLE_DATES_FAILED,
  FETCH_NEXT_AVAILABLE_DATES_LOADING,
  FETCH_NEXT_AVAILABLE_DATES_SUCCEEDED,
  type NextAvailableDateActions,
} from '~shared/actions/nextAvailableDates';
import { mapNextAvailableDateResponsesToDates } from '~shared/features/next-available-date/helpers/mapNextAvailableDateResponsesToDates';
import { type NextAvailableDate } from '~shared/types/clients';

export type NextAvailableDateMapping = Record<string, NextAvailableDate>;

export type NextAvailableDateState = {
  requestAttemptCount: number;
  lastRequestAttemptedAt: number;
  dates: NextAvailableDateMapping;
};

const initialState: NextAvailableDateState = {
  requestAttemptCount: 0,
  lastRequestAttemptedAt: 0,
  dates: {},
};

const nextAvailableDates = (
  state: NextAvailableDateState = initialState,
  action: NextAvailableDateActions,
): NextAvailableDateState => {
  switch (action.type) {
    case FETCH_NEXT_AVAILABLE_DATES_LOADING: {
      return { ...state, requestAttemptCount: state.requestAttemptCount + 1 };
    }

    case FETCH_NEXT_AVAILABLE_DATES_SUCCEEDED: {
      const newDates = action.payload ? mapNextAvailableDateResponsesToDates(action.payload) : {};

      return {
        ...state,
        lastRequestAttemptedAt: Date.now(),
        requestAttemptCount: 0,
        dates: {
          ...state.dates,
          ...newDates,
        },
      };
    }

    case FETCH_NEXT_AVAILABLE_DATES_FAILED:
      return { ...state, lastRequestAttemptedAt: Date.now() };

    default:
      return state;
  }
};

export default nextAvailableDates;
